import { render, staticRenderFns } from "./EzForm.vue?vue&type=template&id=055c16c3&scoped=true&"
import script from "./EzForm.vue?vue&type=script&lang=js&"
export * from "./EzForm.vue?vue&type=script&lang=js&"
import style0 from "./EzForm.vue?vue&type=style&index=0&id=055c16c3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055c16c3",
  null
  
)

export default component.exports